import styled from "styled-components";
import colors from "../../../../config/colors";
import fonts from "../../../../config/fonts";
import { isMobile } from "../../../../utils/common";

export const SideMenuContainer = styled.div`
  position: fixed;
  left: 0px;
  ${isMobile() ? "bottom:0" : "top:0"};
  width: 50px;
  height: 100vh;
  background-color: ${colors.darkPrimary}cc;
  backdrop-filter:blur(5px);
  overflow-x: hidden;
  border: solid 1px ${colors.darkPrimary};
  ${fonts.headings};
  transition: all 0.2s;
  z-index: 10;
  :hover {
    ${isMobile() ? `` : `width: 300px`};
  }

  ${isMobile() &&
  `
      bottom:0;
      width:100vw;
      height:50px;
      display:flex;
      align-items:center;
    `}
`;

export const TitleSection = styled.div`
  background-color: ${colors.background};
  display: flex;
  align-items: center;
  font-size: 20px;
  :hover{
    cursor:pointer;
  }
  ${isMobile() &&
    `
      position: fixed;
    `}
`;
export const AppIcon = styled.img`
  height: 48px;
  width: 48px;
`;
export const TitleText = styled.div`
margin-left: 15px;
  ${isMobile() &&
  `
    display: none;
  `}
`;
export const MenuOptionList = styled.div`
  color: ${colors.background};
  font-size: 18px;
  ${isMobile() &&
  `
      display: flex;
      align-items:center;
      justify-content:center;
      width:100vw;;
    `}
`;
export const MenuOption = styled.div`
  background-color: ${(props) =>
    props.active ? colors.primary : "none"};
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  :hover {
    background-image: linear-gradient(
      to bottom right,
      #0000,
      ${colors.secondary}88
    );
  }
  :active {
    background-image: linear-gradient(
      to bottom right,
      #0000,
      ${colors.secondary}
    );
  }
`;
export const MenuOptionImage = styled.div`
  height: 25px;
  width: 25px;
  margin: 12.5px;
`;
export const MenuOptionText = styled.div`
  margin-left: 15px;
  overflow: hidden;
  white-space: nowrap;
  ${isMobile() &&
  `
      display: none;
    `}
`;
